
import Vue from "vue";
export default Vue.extend({
  name: "ImprintPage",
  props: { productType: String },
});
